// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"28":"745e592c28b35257","612":"19ccba34b500fa8d"}[chunkId] + ".js";
};